import { library } from '@fortawesome/fontawesome-svg-core';

import { faYoutube, faGoogle, faMeta } from '@fortawesome/free-brands-svg-icons';

// configure
library.add(faYoutube, faGoogle, faMeta);
